/* eslint-disable import/no-cycle */
import {observer} from 'mobx-react-lite';
import {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBarcode} from '@fortawesome/free-solid-svg-icons';
import {WidgetLayout} from '../../models/widgetLayout';
import {WidgetLayouts} from '../shared/widgets/WidgetLayouts';
import ModelProperties from '../shared/descriptions/ModelProperties';
import OperatorWidget from '../operator/shared/OperatorWidget';
import {useMount} from '../../hooks/useMount';
import {Barcode} from '../shared/Barcode';
import {useStore} from '../../hooks/useStore';
import {ScopeContext} from '../../policies/scopeContext';
import {orderManagement, workflow} from '../../models/scope';
import {EnDash} from '../shared/unicodeWrapper/EnDash';
import './ActiveOperationDetailsWidget.scss';
import {AttributeLabelLayout, BarcodeWidgetConfig} from './barcodeWidgetConfig';

const BarcodeWidget = ({disabled, identifier}) => {
  const store = useStore();
  const [refresh, setRefresh] = useState(false);
  const widgetConfig = new BarcodeWidgetConfig(store, BarcodeWidget.identifier);

  // Sometimes, custom properties are loaded too late. This updates the component once, they are available.
  useMount(() => {
    setRefresh(!refresh);
  }, [store.propertyStore.properties.length]);

  const attributeLabelLayout = widgetConfig.getAttributeLabelLayout();
  const showBarcodeValueAsString = widgetConfig.showBarcodeValueAsString();
  const barcodeWidth = widgetConfig.getBarcodeWidth();
  const barcodeHeight = widgetConfig.getBarcodeHeight();
  let properties = widgetConfig.getWidgetProperties();

  properties = properties.map((property) => {
    const newProperty = {...property};
    newProperty.render = (text, model) => {
      const value = property.render(text, model);
      if (value.children === EnDash() || value.children === '') {
        return EnDash();
      }
      return {
        children: (
          <div style={{width: '100%', textAlign: 'center'}}>
            <Barcode
              value={value.children}
              displayValue={showBarcodeValueAsString}
              width={barcodeWidth}
              height={barcodeHeight}
            />
          </div>
        ),
      };
    };
    return newProperty;
  });

  const itemLabelStyle = attributeLabelLayout === AttributeLabelLayout.TOP
    ? {textAlign: 'center', width: '100%', display: 'block'}
    : undefined;

  return (
    <ScopeContext.Provider value={[workflow, orderManagement]}>
      <OperatorWidget
        title={widgetConfig.getWidgetSetting('title')}
        icon={<FontAwesomeIcon icon={faBarcode}/>}
        disabled={disabled}
        identifier={identifier}
        widgetConfig={widgetConfig}
      >
        <ModelProperties
          size={widgetConfig.getSpaceSize()}
          showPropertyLabels={attributeLabelLayout !== AttributeLabelLayout.NOT_VISIBLE}
          loading={store.operationStore.isLoadingCollection}
          properties={properties}
          model={store.operationStore.active}
          layout={attributeLabelLayout === AttributeLabelLayout.TOP ? 'vertical' : undefined}
          itemLabelStyle={itemLabelStyle}
        />
      </OperatorWidget>
    </ScopeContext.Provider>
  );
};

BarcodeWidget.identifier = 'BarcodeWidget';
BarcodeWidget.defaultLayout = new WidgetLayout(
  {
    identifier: BarcodeWidget.identifier,
    x: 0,
    y: 1,
    height: 10,
    minHeight: 1,
    width: WidgetLayouts.thirdWidth.w,
    minWidth: WidgetLayouts.thirdWidth.minW,
  }
);

export default observer(BarcodeWidget);
